module.exports = __webpack_public_path__ + "static/media/icon_layout.ede2b854.png";